import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { useEffect } from 'react'
import { getStepComponent } from './stepRegistry'

/**
 * OnboardingSteps Component
 * 
 * Main router for onboarding flow. Uses the step registry pattern to render
 * the appropriate component based on the current step.
 * 
 * Benefits of this approach:
 * - No large switch statement
 * - Easy to add/remove steps
 * - Centralized step management
 * - Better testability
 */
export const OnboardingSteps = () => {
   const currentStep = useOnboardingStoreV2().getCurrentStep()

   // Scroll to top when step changes for better UX
   useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }, [currentStep])

   // Get the component for the current step from the registry
   const StepComponent = getStepComponent(currentStep)

   // Render the step component, or null if not found
   return StepComponent ? <StepComponent /> : null
}
